'use strict';

var minimatch = require('minimatch');
var arrayUnion = require('array-union');
var arrayDiffer = require('array-differ');
var arrify = require('arrify');
module.exports = function (list, patterns) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  list = arrify(list);
  patterns = arrify(patterns);
  if (list.length === 0 || patterns.length === 0) {
    return [];
  }
  return patterns.reduce(function (result, pattern) {
    var process = arrayUnion;
    if (pattern[0] === '!') {
      pattern = pattern.slice(1);
      process = arrayDiffer;
    }
    return process(result, minimatch.match(list, pattern, options));
  }, []);
};